import { Reservation } from 'models/reservation';

export const isFreePassReservation = (reservation: Reservation | null): boolean => {
  return (
    Boolean(reservation?.free_start_date_time_to) && Boolean(reservation?.free_start_date_time_to)
  );
};
